"use strict";

(function(){

let self = Fotobook.WeekendMap = {
    DAY_TYPE_REGULAR : 0,
    DAY_TYPE_WEEKEND : 1,
    DAY_TYPE_WEEKEND_SECONDARY : 2,

    map: [0,0,0,0,0,0,0],

    setMap: function(data){
        this.map = data;
    },
    dayOfWeek: function(day){
        if (day instanceof Date){
            day = day.getDay();
        }
        return day;
    },
    getDayType: function(day){
        return this.map[this.dayOfWeek(day)];
    },
    isWeekend: function(day){
        return this.map[this.dayOfWeek(day)] !== this.DAY_TYPE_REGULAR;
    },
    isPrimaryWeekend: function(day){
        return this.map[this.dayOfWeek(day)] === this.DAY_TYPE_WEEKEND;
    },
    isSecondaryWeekend: function(day){
        return this.map[this.dayOfWeek(day)] === this.DAY_TYPE_WEEKEND_SECONDARY;
    },
    isRegular: function(day){
        return this.map[this.dayOfWeek(day)] === this.DAY_TYPE_REGULAR;
    },

};


$(document)
.on(Fotobook.events.APPCONFIG_CHANGED, function(){
    self.setMap(Fotobook.config.data[Fotobook.Settings.REGIONAL_WEEKENDS]);
})
;

if (Fotobook.config){
    self.setMap(Fotobook.config.data[Fotobook.Settings.REGIONAL_WEEKENDS]);
}

})();
